import React, { useState, useEffect} from 'react';
import { useNavigate } from "react-router";

import Sidenav from './Sidenav.js'
import Header from './Header.js'
import {Sketchbook, DynamicSketchbook} from './Sketchbook.js'
import SketchbookDetail from './SketchbookDetail.js'
import Footer from './Footer.js';

import './App.css';

const App = (props) => {

	const [showScrollbar, setShowScrollbar] = useState(true);

	const [sidenavOpen, setSidenavOpen] = useState(false);
	const [sketchbookDetailOpen, setSketchbookDetailOpen] = useState(false);

	useEffect(() => {
		setShowScrollbar(!sketchbookDetailOpen);
	}, [sketchbookDetailOpen]);

	useEffect(() => {
		if (showScrollbar) {
			document.body.style.overflowY = 'auto';
		} else {
			document.body.style.overflowY = 'hidden';
		}
	}, [showScrollbar]);

	useEffect(() => {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
	}, [])

	let navigate = useNavigate();

	return (
		<div>
			<Sidenav
				setSidenavOpen={setSidenavOpen}
				isSidenavOpen={sidenavOpen && !sketchbookDetailOpen}
				setSketchbookDetailOpen={() => setSketchbookDetailOpen(true)}/>
			<SketchbookDetail
				setSketchbookDetailOpen={setSketchbookDetailOpen}
				isSketchbookDetailOpen={sketchbookDetailOpen}/>
			<Header
				hideHeader={sidenavOpen || sketchbookDetailOpen}
				setSidenavOpen={setSidenavOpen}/>
			<div className={`main-content`}>
				<Sketchbook
					imgOneUrl='./res/photos/Sophie-Mutevelian-1.jpg'
					imgOneDetail={'Photo by <a href="https://www.sophiemutevelian.com" target="_blank" rel="noopener noreferrer">Sophie Mutevelian</a>'}/>
				<DynamicSketchbook
					descTitle={'\
						Manx Minx & Mini-Figure.<br>\
						Various Preparatory Studies/Portraits.<br>\
						M & M & K Toy.<br>\
						Blue Biro.<br>\
						Pencil.<br>\
						White emulsion paint.<br>\
						Repurposed Book.<br>\
						Date Stamped.\
					'}
					imgInfos={[
						{url: './res/drawings/7.jpeg'},
						{url: './res/drawings/1.jpeg'},
						{url: './res/drawings/9.jpg'},
						{url: './res/drawings/10.jpg'},
						{url: './res/drawings/3.jpeg'},
					]}
					reverseColumns={true}/>
				<Sketchbook
					title={'Grayson Perry as Claire.'}
					showDescriptionIcon={true}
					onDescriptionIconClick={() => navigate('/grayson-as-claire')}
					imgOneUrl='./res/gifs/Grayson-Perry-1.gif'
					imgOneDetail='© 2026 Jill Bryars.'/>
			</div>
			<div className='footer-content'>
				<Footer/>
			</div>
		</div>
	);

}

export default App;